module.exports = __webpack_public_path__ + "img/6ad1111.svg";